import * as amplitude from '@amplitude/analytics-browser';

import { i18nMoment } from 'wanderu-i18n';

import type {
    ActiveSortType,
    SearchParams,
} from '../../../../types';

export function dayButtonClicked({
    activeSortType,
    date,
    price,
    searchParams,
}: {
    activeSortType: ActiveSortType,
    date: string,
    price?: number,
    searchParams: SearchParams,
}) {
    const displayDateUTC = i18nMoment.utc(date, 'YYYY-MM-DD');
    const searchDepartUTC = i18nMoment.utc(searchParams.departDate, 'YYYY-MM-DD');
    const searchReturnUTC = i18nMoment.utc(searchParams.departDate, 'YYYY-MM-DD');
    const nowUTC = i18nMoment.utc(i18nMoment().format('YYYY-MM-DD'), 'YYYY-MM-DD');
    const searchedOffset = displayDateUTC.diff(searchDepartUTC, 'days');

    const daysToDeparture = displayDateUTC.diff(nowUTC, 'days');
    const tripLength = searchReturnUTC.diff(searchDepartUTC, 'days') + 1;

    amplitude.track('search_submitted', {
        arrival_location: {
            arrival_place_id: searchParams.destinationPlaceId,
            arrival_place_name: searchParams.destinationText,
        },
        current_sort_method: activeSortType,
        date_selected_value: price,
        days_to_departure: daysToDeparture,
        departure_date_searched_offset: searchedOffset,
        departure_location: {
            departure_place_id: searchParams.originText,
            departure_place_name: searchParams.originText,
        },
        funnel_stage: 'search',
        is_one_way: !searchParams.returnDate,
        outbound_date_searched: searchParams.departDate,
        return_date_searched: searchParams.returnDate,
        search_method: 'date_buttons',
        trip_length_in_days: tripLength,
    });
}
